module.exports = __webpack_public_path__ + "img/4.6c0b3103.png";